// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SpatialExtent
 */
export interface SpatialExtent {
  /**
   * A spatial bounding box of 4 floats (x1, y1, x2, y2). For WGS84 we use traditional (x=lon, y=lat) order.
   */
  bbox: Array<number>;
  /**
   * The Coordinate Reference System as an EPSG code, for example: 'EPSG:123456'. Raster transformations are done using PROJ4 version 9.6.0.
   */
  crs?: string;
}

/**
 * Check if a given object implements the SpatialExtent interface.
 */
export function instanceOfSpatialExtent(value: object): value is SpatialExtent {
  if (!("bbox" in value) || value["bbox"] === undefined) return false;
  return true;
}

export function SpatialExtentFromJSON(json: any): SpatialExtent {
  return SpatialExtentFromJSONTyped(json, false);
}

export function SpatialExtentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpatialExtent {
  if (json == null) {
    return json;
  }
  return {
    bbox: json["bbox"],
    crs: json["crs"] == null ? undefined : json["crs"],
  };
}

export function SpatialExtentToJSON(json: any): SpatialExtent {
  return SpatialExtentToJSONTyped(json, false);
}

export function SpatialExtentToJSONTyped(
  value?: SpatialExtent | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bbox: value["bbox"],
    crs: value["crs"],
  };
}
